import {
  AccountIdentity,
  accountIdentity,
  AnyAccountId,
  anyAccountId,
  RoomContextId,
  roomContextId,
  RoomId,
  roomId,
  StreamId,
  streamId,
  StreamIsActive,
  streamIsActive,
  StreamKind,
  streamKinds
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStreamUpdateEventDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamUpdateEventDTO.validationSchema()
  );

  constructor(readonly data: RoomStreamUpdateEventDTORaw) {
    JsonSchemaValidator.assert(RoomStreamUpdateEventDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: [
        "accountId",
        "accountIdentity",
        "roomId",
        "roomContextId",
        "streamIsActive",
        "streamId",
        "streamKinds"
      ],
      properties: {
        accountId: anyAccountId,
        accountIdentity: accountIdentity,
        roomId,
        roomContextId,
        streamIsActive,
        streamId,
        streamKinds
      },
      additionalProperties: false
    };
  }
}

export interface RoomStreamUpdateEventDTORaw {
  accountId: AnyAccountId;
  accountIdentity: AccountIdentity;
  roomId: RoomId;
  roomContextId: RoomContextId;
  streamIsActive: StreamIsActive;
  streamId: StreamId;
  streamKinds: StreamKind[];
}
